import Vue from 'vue'

export const namespaced = true

export const state = {
  invoice_account: {},
}

export const mutations = {
  SET_INVOICE_ACCOUNT(state, invoice_account) {
    state.invoice_account = invoice_account
  },
  CLEAR_INVOICE_ACCOUNT(state) {
    state.invoice_account = {}
  },
}

export const actions = {
  fetchInvoiceAccount({ commit, dispatch, getters, rootState }, order_id) {
    return new Promise((resolve, reject) => {
      // console.log(`fetchInvoiceAccount order id ${order_id} url ${rootState.application.urls.invoice_account}`)
      let invoice_account = getters.getInvoiceAccount()
      if (invoice_account && invoice_account.account_type) {
        // console.log(`  - invoice account retrieved from cache`, invoice_account)
        resolve(invoice_account)
      } else {
        dispatch('layout/set_loading', true, { root: true })
        const url = rootState.application.urls.invoice_account.replace(':order_id', order_id)
        return Vue.http.get(url, null, {
          responseType: 'json',
        })
          .then(response => {
            invoice_account = response.data
            commit('SET_INVOICE_ACCOUNT', invoice_account)
            dispatch('layout/set_loading', false, { root: true })
            resolve(invoice_account)
          })
          .catch(error => {
            // console.log('fetchInvoiceAccount There was an error:', error.response ? error.response : error)
            dispatch('layout/set_loading', false, { root: true })
            reject(error)
          })
      }
    })
  },
  newInvoiceAccount({ commit }, invoice_account) {
    commit('SET_INVOICE_ACCOUNT', invoice_account)
  },
  clearInvoiceAccount({ commit }) {
    commit('CLEAR_INVOICE_ACCOUNT')
  },
  createInvoiceAccount({ commit, dispatch, rootState }, [order_id, invoice_account]) {
    return new Promise((resolve, reject) => {
      console.log(`createInvoiceAccount id ${order_id} invoice_account ${invoice_account}`)
      const url = rootState.application.urls.invoice_account.replace(':order_id', order_id)
      Vue.http.post(url, {
        invoice_account: invoice_account,
      }).then(response => {
        invoice_account = response.body
        commit('SET_INVOICE_ACCOUNT', invoice_account)
        commit('order/SET_INVOICE_ACCOUNT_ID', invoice_account.id, { root: true })
        commit('order/REFRESH_ORDER_IN_ORDERS', rootState.order.order, { root: true })
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  updateInvoiceAccount({ commit, dispatch, rootState }, [order_id, invoice_account]) {
    return new Promise((resolve, reject) => {
      const url = rootState.application.urls.invoice_account.replace(':order_id', order_id)
      Vue.http.put(url, {
        invoice_account: invoice_account,
      }).then(response => {
        let invoice_acc_id = '';
        if (invoice_account.id){
          invoice_acc_id = invoice_account.id;
        }else{
          response.body.map((elem)=>{
            if (elem.fiscal_code){
              if (elem.fiscal_code.toLowerCase() == invoice_account.fiscal_code ){
                invoice_acc_id = elem.id;
              }
            }

          });
        }
        commit('SET_INVOICE_ACCOUNT', response.body)
        commit('order/SET_INVOICE_ACCOUNT_ID', invoice_acc_id, { root: true })
        commit('order/REFRESH_ORDER_IN_ORDERS', rootState.order.order, { root: true })
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  associateInvoiceAccountFromOta({ commit, dispatch, rootState }, {order_id}) {
    return new Promise((resolve, reject) => {
      const url = rootState.application.urls.invoice_account_associate_ota.replace(':order_id', order_id)
      Vue.http.put(url, {}
      ).then(response => {
        const invoice_account = response.body
        commit('SET_INVOICE_ACCOUNT', invoice_account)
        commit('order/SET_INVOICE_ACCOUNT_ID', invoice_account.id, { root: true })
        commit('order/REFRESH_ORDER_IN_ORDERS', rootState.order.order, { root: true })
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
}

export const getters = {
  getInvoiceAccount: state => () => {
    return Object.keys(state.invoice_account).length === 0 ? null : state.invoice_account
  },
}
